/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: ba-ui-common (C) Copyright IBM Corp. 2016, 2017, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Container } from '@waca/ca-ui-toolkit';
import './PanelMessage.scss';

export default class PanelMessage extends Component<any, any> {
	static propTypes = {
		children: PropTypes.node,
		topOffset: PropTypes.number,
		contentGutter: PropTypes.oneOfType([PropTypes.number, PropTypes.array]),
	};

	render() {
		const { children, topOffset, contentGutter } = this.props;
		const style = topOffset
			? {
					top: `${topOffset}px`,
					overflow: 'auto',
			  }
			: {};

		return (
			<Container className="bi-common-panelMessage" style={style}>
				<Container className="bi-common-panelMessage__inner">
					<Container className="bi-common-panelMessage__contents" gutter={contentGutter}>
						{children}
					</Container>
				</Container>
			</Container>
		);
	}
}
